var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You will receive a billing statement via email on the 15th of each month between September and June. Your monthly dues will then be pulled from your designated account with autopay on the 25th of the month.")])}
var staticRenderFns = []

export { render, staticRenderFns }